import { FC } from 'react';

import { Menu, ProSidebar, SidebarContent } from 'react-pro-sidebar';

import classnames from 'classnames';

import { useUniqueKey } from '@hsp/react-hooks';

import { useSidebarStore } from 'store/sidebar';
import { buildMenu } from 'utilities/menu';

import { NavItem } from './components';

import 'react-pro-sidebar/dist/css/styles.css';
import './sidebar.component.scss';

const Sidebar: FC = () => {
  const isOpen = useSidebarStore((state) => state.open);
  const uniqueKey = useUniqueKey();

  return (
    <div className={classnames('sidebar', { open: isOpen })}>
      <ProSidebar>
        <Menu className={classnames({ open: isOpen })}>
          <SidebarContent>
            {buildMenu().map((item) => (
              <NavItem
                key={uniqueKey(item)}
                {...item}
              />
            ))}
          </SidebarContent>
        </Menu>
      </ProSidebar>
    </div>
  );
};

export default Sidebar;
